import script from "./execution-phase-events.vue?vue&type=script&setup=true&lang=ts"
export * from "./execution-phase-events.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__